import { render, staticRenderFns } from "./AddNewStoreForm.vue?vue&type=template&id=149920d8&"
import script from "./AddNewStoreForm.vue?vue&type=script&lang=js&"
export * from "./AddNewStoreForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports